namespace('IO.Views.PaymentDevices', function (exports) {
  'use strict';

  exports.Details = exports.New;
});
